<div class="row">
  <div *ngIf="!packagingLabel.id" class="col-lg-12">
    <div class="pull-left pt-2">{{'doctrine.order.generate_packaging_label' | translate}} *</div>
    <div class="pull-right">
      <button type="button" class="btn btn-primary" (click)="openGenerateModal()" [disabled]="!isActive || serviceRequest.isArchived">{{'global.generate'|translate}}</button>
    </div>
  </div>
  <div *ngIf="packagingLabel.id" class="col-lg-12">
    <p class="pb-2">{{'doctrine.solution.action_packaging_label.check_file' | translate}}</p>
    <button type="button" class="btn btn-primary btn-file" (click)="openPdfFile()">
      <i class="fa fa-file-pdf-o"></i>
    </button>
  </div>
</div>
<app-generate-packaging-label
  #generateModal="generatePackagingLabel"
  [packagingLabel]="packagingLabel"
  ($resultPL)="updatePackagingLabel($event)"
  [hideDeliveryDealer]="true"
>
</app-generate-packaging-label>
<a #downloadLink href="" download style="display: none"></a>
